import { useState } from 'react';
import { LocalStorageEnum } from './enums';
import { PriceDisplayMode } from './types';
export const PRICE_DISPLAY_MODE_CHANGE_EVENT = 'priceDisplayModeChanged';
export const usePriceDisplayMode = () => {
    const [displayMode, setDisplayMode] = useState(() => {
        var _a;
        if (typeof window !== 'undefined') {
            return ((_a = window.localStorage.getItem(LocalStorageEnum.PRICE_DISPLAY_MODE)) !== null && _a !== void 0 ? _a : PriceDisplayMode.TotalPrice);
        }
        return PriceDisplayMode.TotalPrice;
    });
    const setPriceDisplayMode = (newMode) => {
        setDisplayMode(newMode);
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(LocalStorageEnum.PRICE_DISPLAY_MODE, newMode);
            // Dispatch custom event for intra-tab communication
            window.dispatchEvent(new CustomEvent(PRICE_DISPLAY_MODE_CHANGE_EVENT, {
                detail: newMode,
            }));
        }
    };
    return [displayMode, setPriceDisplayMode];
};
